var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    width: 13.664,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.111 0a5.986 5.986 0 0 0 -5.062 9.179l-.013.005-2.6 2.6 2.208 2.216 2.7-2.7v-.011a5.985 5.985 0 1 0 2.767-11.289zm0 2.658a3.326 3.326 0 1 1 -3.325 3.326 3.326 3.326 0 0 1 3.325-3.326z",
    fill: "#3c2f87",
    transform: "translate(-.432)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.56d5d808a5c9d72bff62082e73af9cb1.svg";
export { ForwardRef as ReactComponent };